module.exports = __webpack_public_path__ + "static/media/Polygon 1.ac51fff7.png";